import { SVGProps } from "react";

const UndrawDecide: React.FC<SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 649.675 226.13"
      {...props}
    >
      <path
        //   data-name="Path 680"
        d="M87.921 0a3.788 3.788 0 0 0 0 7.575h76.834a3.788 3.788 0 1 0 0-7.575Z"
        fill="#3f3d56"
      />
      <path
        //   data-name="Path 681"
        d="M87.921 22.316a3.788 3.788 0 0 0 0 7.575h76.834a3.788 3.788 0 0 0 0-7.575Z"
        fill="#3f3d56"
      />
      <path
        //   data-name="Path 682"
        d="M126.339 93.09a23.84 23.84 0 1 1 23.84-23.842 23.869 23.869 0 0 1-23.84 23.842Z"
        fill="#e4e4e4"
      />
      <path
        //   data-name="Path 680"
        d="M484.921 0a3.788 3.788 0 1 0 0 7.575h76.834a3.788 3.788 0 0 0 0-7.575Z"
        fill="#3f3d56"
      />
      <path
        //   data-name="Path 681"
        d="M484.921 22.316a3.788 3.788 0 0 0 0 7.575h76.834a3.788 3.788 0 0 0 0-7.575Z"
        fill="#3f3d56"
      />
      <path
        //   data-name="Path 682"
        d="M523.339 93.09a23.84 23.84 0 1 1 23.84-23.842 23.869 23.869 0 0 1-23.84 23.842Z"
        fill="#e4e4e4"
      />
      <ellipse
        cx="484.902"
        cy="475.492"
        rx="7.195"
        ry="22.919"
        transform="rotate(-64.626 80.964 524.548)"
        fill="#2f2e41"
      />
      <ellipse
        cx="585.287"
        cy="504.72"
        rx="7.195"
        ry="22.919"
        transform="rotate(-39.938 -15.931 714.887)"
        fill="#2f2e41"
      />
      <circle cx="261.37" cy="159.826" r="45.839" fill="#2f2e41" />
      <path
        fill="#2f2e41"
        d="M266.846 195.801h13.926v24.95h-13.926zM238.994 195.801h13.926v24.95h-13.926z"
      />
      <ellipse
        cx="269.167"
        cy="221.041"
        rx="11.605"
        ry="4.352"
        fill="#2f2e41"
      />
      <ellipse
        cx="241.315"
        cy="220.461"
        rx="11.605"
        ry="4.352"
        fill="#2f2e41"
      />
      <path
        d="M246.976 102.205c4.093-16.483 22.16-26.183 40.355-21.666s29.625 21.543 25.532 38.027-17.672 16.537-35.866 12.019-34.114-11.896-30.02-28.38Z"
        fill="#83c673"
      />
      <circle cx="254.517" cy="150.154" r="15.283" fill="#fff" />
      <circle cx="248.235" cy="144.676" r="5.094" fill="#3f3d56" />
      <path
        d="M264.104 181.994a10.188 10.188 0 0 1-20.048 3.65l-.003-.02c-1.003-5.537 3.278-7.496 8.815-8.499s10.233-.668 11.236 4.87Z"
        fill="#fff"
      />
      <ellipse
        cx="715.098"
        cy="475.492"
        rx="22.919"
        ry="7.195"
        transform="rotate(-25.374 -170.817 918.16)"
        fill="#2f2e41"
      />
      <ellipse
        cx="614.713"
        cy="504.72"
        rx="22.919"
        ry="7.195"
        transform="rotate(-50.062 116.36 630.883)"
        fill="#2f2e41"
      />
      <circle cx="388.306" cy="159.826" r="45.839" fill="#2f2e41" />
      <path
        fill="#2f2e41"
        d="M368.904 195.801h13.926v24.95h-13.926zM396.755 195.801h13.926v24.95h-13.926z"
      />
      <ellipse
        cx="380.509"
        cy="221.041"
        rx="11.605"
        ry="4.352"
        fill="#2f2e41"
      />
      <ellipse cx="408.36" cy="220.461" rx="11.605" ry="4.352" fill="#2f2e41" />
      <path
        d="M402.699 102.205c-4.093-16.483-22.16-26.183-40.355-21.666s-29.625 21.543-25.532 38.027 17.672 16.537 35.867 12.019 34.113-11.896 30.02-28.38Z"
        fill="#83c673"
      />
      <circle cx="395.159" cy="150.154" r="15.283" fill="#fff" />
      <circle cx="401.44" cy="144.676" r="5.094" fill="#3f3d56" />
      <path
        d="M385.572 181.994a10.188 10.188 0 0 0 20.047 3.65l.004-.02c1.002-5.537-3.279-7.496-8.816-8.499s-10.233-.668-11.235 4.87Z"
        fill="#fff"
      />
      <path
        d="M648.485 226.13H1.19a1.19 1.19 0 0 1 0-2.382h647.294a1.19 1.19 0 0 1 0 2.382Z"
        fill="#3f3d56"
      />
    </svg>
  );
};

export default UndrawDecide;
